import { divider, primary } from '../Styles/Colours';
import { LinearProgress, withStyles } from '@material-ui/core';
export var ColorLinearProgress = withStyles({
    colorPrimary: {
        backgroundColor: divider
    },
    barColorPrimary: {
        backgroundColor: primary
    }
})(LinearProgress);
